<div class="row animated fadeIn fast">

    <div class="col-lg-12">
        <div class="card">

            <div class="card-body">
                <form class="form p-t-20"
                      [formGroup]="cliForm"
                      (ngSubmit)="enviar()"
                      class="form-horizontal">
                    <div class="form-body">

                        <div class="row">
                            <div class="col ml-2 mb-2">
                                <h4><b>{{ cliente.nombre }}</b></h4>
                                <span class="ml-2">{{ cliente.direccion }} ({{ cliente.cp }} - {{ cliente.poblacion }}) </span>
                            </div>

                            <!-- BOTONES: Archivar / Datos de facturación / Intranet -->
                            <app-botonera [cliente]="cliente"
                                          [loading]="loading"
                                          [activeTab]="'intranet'"></app-botonera>
                        </div>
                        <hr>

                        <div class="card mt-2 border border-secondary rounded configCard">

                            <div class="card-body mt-0">

                                <div class="row">

                                    <!-- acceso_intranet -->
                                    <div class="col-md-12">
                                        <div class="form-group"
                                             [ngClass]="{ 'has-danger': enviado && f['acceso_intranet'].errors }">
                                            <label> <i class="fa-solid fa-laptop"></i> Acceso a la Intranet de cliente</label>
                                            <div class="custom-control custom-radio">
                                                <input formControlName="acceso_intranet"
                                                       type="radio"
                                                       class="custom-control-input"
                                                       id="acceso_si"
                                                       value="S"
                                                       [checked]="cliForm.get('acceso_intranet')?.value === 'S'"
                                                       (change)="accesoIntranetChange()">
                                                <label class="custom-control-label"
                                                       for="acceso_si">Sí</label>
                                            </div>
                                            <div class="custom-control custom-radio">
                                                <input formControlName="acceso_intranet"
                                                       type="radio"
                                                       class="custom-control-input"
                                                       id="acceso_no"
                                                       value="N"
                                                       [checked]="cliForm.get('acceso_intranet')?.value === 'N'"
                                                       (change)="accesoIntranetChange()">
                                                <label class="custom-control-label"
                                                       for="acceso_no">No</label>
                                            </div>
                                            <div *ngIf="enviado && f['acceso_intranet'].errors"
                                                 class="form-control-feedback">
                                                <div *ngIf="cliForm.get('acceso_intranet')?.errors?.['apiError']">
                                                    {{cliForm.get('acceso_intranet')?.errors?.['apiError']}}
                                                </div>
                                            </div>
                                            <p>
                                                <small class="text-info mb-0 ml-2">¿El cliente podrá tener usuarios de Intranet?</small>
                                            </p>
                                        </div>
                                    </div>

                                </div>

                                <hr *ngIf="cliForm.get('acceso_intranet')?.value === 'S'"
                                    class="text-info mt-0 mb-3">

                                <div class="w-100"
                                     *ngIf="cliForm.get('acceso_intranet')?.value === 'S'">

                                    <!-- email_intranet -->
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-md-5">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['email_intranet'].errors }">
                                                <label for="email_intranet">Email de recepción de solicitudes, A esta dirección de eMail se enviarán los avisos. (De cliente -> A InnovaCen):</label>
                                                <input type="text"
                                                       formControlName="email_intranet"
                                                       class="form-control"
                                                       [ngClass]="{ 'form-control-danger': enviado && f['email_intranet'].errors }">
                                                <div *ngIf="enviado && f['email_intranet'].errors"
                                                     class="form-control-feedback">
                                                    <div *ngIf="f['email_intranet'].errors['required']">Obligatorio</div>
                                                    <div *ngIf="f['email_intranet'].errors['eMailFormat']">No parece un eMail válido</div>
                                                    <div *ngIf="cliForm.get('email_intranet')?.errors?.['apiError']">
                                                        {{cliForm.get('email_intranet')?.errors?.['apiError'] }}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>



                                    <hr>
                                    <p>Configuradores:</p>


                                    <!--  <span class="mr-3 small text-info">Entradas</span> -->

                                    <!-- intranet_enviaEmailEntradaValidada -->
                                    <!-- <div class="row mb-3 align-items-center">
                                        <div class="col-auto">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['intranet_enviaEmailEntradaValidada'].errors }">
                                                <div class="custom-control custom-switch">
                                                    <input formControlName="intranet_enviaEmailEntradaValidada"
                                                           type="checkbox"
                                                           class="custom-control-input"
                                                           id="intranet_enviaEmailEntradaValidada">
                                                    <label class="custom-control-label"
                                                           for="intranet_enviaEmailEntradaValidada">Recibirá un eMail cuando se valide una entrada</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="text-muted"> El cliente recibirá un eMail en <b class="text-primary">{{cliente.email}}</b> cuando el administrador valide o modifique una entrada de mercancía solicitada desde la Intranet</span>
                                        </div>
                                    </div> -->


                                    <span class="mr-3 small text-info">Entradas</span>

                                    <!-- intranet_enviaAvisoEntradaValidada -->
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-auto">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['intranet_enviaAvisoEntradaValidada'].errors }">
                                                <div class="custom-control custom-switch">
                                                    <input formControlName="intranet_enviaAvisoEntradaValidada"
                                                           type="checkbox"
                                                           class="custom-control-input"
                                                           id="intranet_enviaAvisoEntradaValidada">
                                                    <label class="custom-control-label"
                                                           for="intranet_enviaAvisoEntradaValidada">Avisar de entradas validadas</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="text-muted"> Se añadirá un aviso en la intranet del cliente cuando el administrador valide o modifique una entrada de mercancía</span>
                                        </div>
                                    </div>


                                    <span class="mr-3 small text-info">Stock</span>

                                    <!-- agrupa_ubicaciones -->
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-auto">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['agrupa_ubicaciones'].errors }">
                                                <div class="custom-control custom-switch">
                                                    <input formControlName="agrupa_ubicaciones"
                                                           type="checkbox"
                                                           class="custom-control-input"
                                                           id="agrupa_ubicaciones">
                                                    <label class="custom-control-label"
                                                           for="agrupa_ubicaciones">Agrupar ubicaciones del Stock</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="text-muted"> El cliente verá su
                                                Stock agrupado, sin diferenciar entre ubicaciones de un mismo artículo</span>
                                        </div>
                                    </div>


                                    <span class="mr-3 small text-info">Pedidos</span>

                                    <!-- intranet_import_pedidos -->
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-auto">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['intranet_import_pedidos'].errors }">
                                                <div class="custom-control custom-switch">
                                                    <input formControlName="intranet_import_pedidos"
                                                           type="checkbox"
                                                           class="custom-control-input"
                                                           id="intranet_import_pedidos">
                                                    <label class="custom-control-label"
                                                           for="intranet_import_pedidos">Puede Importar ficheros excel de pedidos</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="text-muted"> El cliente podrá importar ficheros .xlsx con pedidos desde la intranet en formato cabecera detalle</span>
                                        </div>
                                    </div>

                                    <!-- intranet_origen_pedidos -->
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-auto">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['intranet_origen_pedidos'].errors }">
                                                <div class="custom-control custom-switch">
                                                    <input formControlName="intranet_origen_pedidos"
                                                           type="checkbox"
                                                           class="custom-control-input"
                                                           id="intranet_origen_pedidos">
                                                    <label class="custom-control-label"
                                                           for="intranet_origen_pedidos">Puede consultar el origen de pedidos</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="text-muted"> El cliente podrá consultar información sobre los estados de los pedidos procesados, así como el origen de los pedidos</span>
                                        </div>
                                    </div>

                                    <!-- intranet_enviaEmailPedidos -->
                                    <div class="row mb-3 align-items-center"
                                         *ngIf="f['email_intranet'].value">
                                        <div class="col-auto">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['intranet_enviaEmailPedidos'].errors }">
                                                <div class="custom-control custom-switch">
                                                    <input formControlName="intranet_enviaEmailPedidos"
                                                           type="checkbox"
                                                           class="custom-control-input"
                                                           id="intranet_enviaEmailPedidos">
                                                    <label class="custom-control-label"
                                                           for="intranet_enviaEmailPedidos">Enviar eMail al crear pedido MANUAL desde la Intranet</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="text-muted"> Se enviará un email a <b class="text-primary">{{f['email_intranet'].value}}</b> con la información del pedido, cada vez que se cree manualmente una solicitud de pedido desde la Intranet</span>
                                        </div>
                                    </div>



                                    <!-- intranet_albaranEnXls -->
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-auto">
                                            <div class="form-group mb-0"
                                                 [ngClass]="{ 'has-danger': enviado && f['intranet_albaranEnXls'].errors }">
                                                <div class="custom-control custom-switch">
                                                    <input formControlName="intranet_albaranEnXls"
                                                           type="checkbox"
                                                           class="custom-control-input"
                                                           id="intranet_albaranEnXls">
                                                    <label class="custom-control-label"
                                                           for="intranet_albaranEnXls">Generar packing List también en Excel</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="text-muted"> Los pedidos del cliente generarán los packing Lists en PDF y XLSX, y podrá descargarlos desde la consulta de pedidos procesados</span>
                                        </div>
                                    </div>


                                </div>

                                <hr *ngIf="cliForm.get('acceso_intranet')?.value === 'S'"
                                    class="text-info mt-0 mb-3">

                                <div class="row">

                                    <!-- codServicios_posibles -->
                                    <div class="col-md-3"
                                         *ngIf="cliForm.get('acceso_intranet')?.value === 'S'">
                                        <div class="form-group"
                                             [ngClass]="{ 'has-danger': enviado && f['codServicios_posibles'].errors }">
                                            <label class="custom-control-label"
                                                   for="codServicios_posibles"
                                                   data-toggle="tooltip"
                                                   title="El cliente podrá seleccionar uno de estos típos de servicio para cada pedido creado desde la intranet">
                                                Servicios seleccionables
                                                <i class="ml-1 text-info fa-solid fa-circle-info"></i>
                                            </label>

                                            <div class="border p-2"
                                                 style="height: 150px; overflow-y: auto; border-radius: 5px;">
                                                <div id="checkboxContainer"
                                                     *ngFor="let option of serviciosList; let i = index"
                                                     class="form-check"
                                                     [ngClass]="{ 'highlight-inte': option.codServicio === 'inte' }">
                                                    <input type="checkbox"
                                                           class="form-check-input"
                                                           [id]="'option' + i"
                                                           [value]="option.codServicio"
                                                           (change)="onCodServicioChange($event)"
                                                           [checked]="codServicios_seleccionados.includes(option.codServicio)" />
                                                    <label class="form-check-label"
                                                           [for]="'option' + i">
                                                        {{ option.nombre }}
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="mt-3">
                                                <span *ngFor="let codServ of codServicios_seleccionados"
                                                      [ngClass]="{'badge-primary': codServ != 'inte', 'badge-warning': codServ == 'inte'}"
                                                      class="badge mr-1">
                                                    {{ codServ }}
                                                </span>
                                            </div>

                                            <div *ngIf="enviado && f['codServicios_posibles'].errors"
                                                 class="form-control-feedback">
                                                <div *ngIf="cliForm.get('codServicios_posibles')?.errors?.['apiError']">{{
                                                    cliForm.get('codServicios_posibles')?.errors?.['apiError'] }}</div>
                                            </div>

                                        </div>

                                    </div>




                                    <!-- codServicio_pred -->
                                    <div class="col-md-3"
                                         *ngIf="cliForm.get('acceso_intranet')?.value === 'S'">
                                        <div class="form-group"
                                             [ngClass]="{ 'has-danger': enviado && f['codServicio_pred'].errors }">
                                            <label class="form-control-label"
                                                   data-toggle="tooltip"
                                                   title="Servicio por defecto al crear nuevos pedidos externos desde la Intranet de Cliente">
                                                Servicio predetermiado:
                                                <i class="ml-1 text-info fa-solid fa-circle-info"></i>
                                            </label>
                                            <select formControlName="codServicio_pred"
                                                    class="form-control"
                                                    [ngClass]="{ 'form-control-danger': enviado && f['codServicio_pred'].errors }">
                                                <option class=" font-bold"
                                                        value="0">Indiferente</option>
                                                <option *ngFor="let servicio of serviciosList"
                                                        [value]="servicio.codServicio"
                                                        [disabled]="!codServicios_seleccionados.includes(servicio.codServicio)">
                                                    {{servicio.nombre}}
                                                </option>
                                            </select>
                                            <div *ngIf="enviado && f['codServicio_pred'].errors"
                                                 class="form-control-feedback">
                                                <div *ngIf="cliForm.get('codServicio_pred')?.errors?.['apiError']">{{
                                                    cliForm.get('codServicio_pred')?.errors?.['apiError'] }}</div>
                                            </div>
                                        </div>
                                    </div>


                                </div> <!-- row -->

                                <hr *ngIf="cliForm.get('acceso_intranet')?.value === 'S'"
                                    class="text-info mt-0 mb-3">

                                <div class="row">


                                    <!-- usuariosList -->
                                    <div class="col-md-12"
                                         *ngIf="cliForm.get('acceso_intranet')?.value === 'S'">
                                        <div class="form-group">
                                            <label class="form-control-label"
                                                   data-toggle="tooltip"
                                                   title="Usuarios con acceso a la intranet para este Cliente">
                                                Usuarios Intranet:
                                                <i class="ml-1 text-info fa-solid fa-circle-info"></i>
                                            </label>

                                            <div *ngIf="usuariosList?.length! > 0; else noUsuarios">
                                                <table class="table table-sm table-bordered rounded border-5">
                                                    <thead>
                                                        <tr>
                                                            <th></th>
                                                            <th>Usuario</th>
                                                            <th>Rol</th>
                                                            <th>Nombre</th>
                                                            <th>eMail</th>
                                                            <th>Editar</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let usuario of usuariosList">
                                                            <td>
                                                                <img [src]="fotoDir +'/users/'+ usuario.foto"
                                                                     loading="lazy"
                                                                     class="rounded-circle"
                                                                     style="width:30px" />
                                                            </td>
                                                            <td>{{usuario.username}}</td>
                                                            <td>
                                                                <span class="badge"
                                                                      [ngClass]="{
                                        'badge-success': usuario.rolIntranet === 'admin', 
                                        'badge-light': usuario.rolIntranet !== 'admin'
                                        }"> {{usuario.rolIntranet}}</span>
                                                            </td>
                                                            <td>{{usuario.nombre}} {{usuario.apellidos}}</td>
                                                            <td>{{usuario.email}}</td>
                                                            <td title="Editar usuario">
                                                                <a (click)="irAEditarUsuario(usuario)"
                                                                   class="text-secondary"
                                                                   style="cursor: pointer;">
                                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <ng-template #noUsuarios>
                                                <ul>
                                                    <li>
                                                        Sin usuarios asignados
                                                    </li>
                                                </ul>
                                            </ng-template>

                                        </div>

                                        <div *ngIf="cliente.id"
                                             class="text-left mb-2">
                                            <button type="button"
                                                    class="btn btn-sm btn-secondary"
                                                    (click)="newUser()"
                                                    data-toggle="tooltip"
                                                    title="Crear un nuevo usuario con acceso a la Intranet de Clientes para este cliente">
                                                <i class="fa-solid fa-user"></i> Crear nuevo usuario de Intranet
                                            </button>
                                        </div>

                                    </div>



                                </div> <!-- row -->

                            </div> <!-- card-body  -->
                        </div> <!-- card -->




                        <hr class="my-4">

                        <div class="d-flex">
                            <button [disabled]="loading"
                                    type="button"
                                    class="btn waves-effect waves-light btn-rounded btn-secondary"
                                    [routerLink]="'/panel/clientes_lista'"
                                    data-dismiss="modal">Cancelar</button>
                            <h6 class="card-subtitle ml-4 ">
                                <li *ngIf="cliente.created_at"> Creado hace {{cliente.created_at! | friendlyDdmmyy}}</li>
                                <li *ngIf="cliente.updated_at"> Última modificación hace {{cliente.updated_at! | friendlyDdmmyy}}</li>
                            </h6>
                            <button [disabled]="loading"
                                    type="submit"
                                    class="ml-auto btn waves-effect waves-light btn-rounded btn-success">
                                <i *ngIf="loading"
                                   class="fa fa-spinner fa-spin"></i>
                                Enviar</button>
                        </div>


                    </div> <!-- form-body -->
                </form>

            </div> <!-- card-body -->

        </div> <!-- card -->
    </div> <!-- col-12 -->

</div> <!-- fadeIn fast -->